import { render, staticRenderFns } from "./type30.vue?vue&type=template&id=6ee7bf72&scoped=true"
import script from "./type30.vue?vue&type=script&lang=js"
export * from "./type30.vue?vue&type=script&lang=js"
import style0 from "./type30.vue?vue&type=style&index=0&id=6ee7bf72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee7bf72",
  null
  
)

export default component.exports